<template>
  <div v-wechat-title="titleTop" class="page-container">
    <header class="header">
      <div class="header-content">
        <a href="javascript:;" @click="goBack" class="back-btn">
          <van-icon name="arrow-left" size="18" />
        </a>
        <h1 class="page-title">{{ $t('title') }}</h1>
        <languageChangeVue/>
      </div>
    </header>

    <main class="main-content">
      <van-skeleton title avatar :row="3" :loading="loading">
        
        <div class="card trip-card">
          <div class="card-image-wrapper">
            <img src="/img/backimg/bindtop.jpg" class="card-img">
            <div class="img-overlay"></div>
            <div class="img-text">
              <p class="img-subtitle">{{ $t('upcoming_trip') }}</p>
              <h2 class="img-title">{{ data.courseName }}</h2>
            </div>
          </div>
          
          <div class="card-body">
            <div class="info-row">
              <div class="icon-box">
                <van-icon name="clock-o" />
              </div>
              <div>
                <p class="label-text">{{ $t('trip_on') }}</p>
                <p class="value-text">{{ startTime }}</p>
              </div>
            </div>
            
            <div class="info-row">
              <div class="icon-box">
                <van-icon name="hotel-o" />
              </div>
              <div v-if="data.subTitle">
                <p class="label-text">{{ $t('cabin') }}</p>
                <p class="value-text">{{ data.subTitle }}</p>
              </div>
              <div v-if="!data.subTitle">
                <p class="label-text">{{ $t('diveCenter') }}</p>
                <p class="value-text">{{ data.diveCenter }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="card info-card">
          <div class="card-header">
            <van-icon name="manager" class="header-icon" />
            <h3 class="header-title">{{ $t('verify_info') }}</h3>
          </div>

          <div class="info-list">
            <div class="info-item">
              <p class="info-label">{{ $t('last_name') }}</p>
              <div class="info-value">{{ data.lastName }}</div>
            </div>

            <div class="info-item">
              <p class="info-label">{{ $t('first_name') }}</p>
              <div class="info-value">{{ data.firstName }}</div>
            </div>

            <div class="info-item">
              <p class="info-label">{{ $t('chinese_name') }}</p>
              <div class="info-value">{{ data.localName }}{{ data.localNameEnd }}</div>
            </div>
          </div>
        </div>

        <div class="tip-box">
          <div class="tip-content">
            <van-icon name="info-o" class="tip-icon" />
            <div class="tip-text">
              <p>{{ $t('tip_1') }}</p>
              <p>{{ $t('tip_2') }}</p>
            </div>
          </div>
        </div>
      </van-skeleton>
    </main>

    <div class="footer">
      <div class="footer-inner">
        <van-button 
          block 
          color="#0057FF"
          class="confirm-btn"
          :loading="buttonLoading"
          :loading-text="$t('loading')"
          @click="onBind"
        >
          {{ $t('btn_confirm') }}
        </van-button>
      </div>
    </div>

    <transition name="fade">
      <div v-if="showSuccessModal" class="modal-overlay">
        <div class="modal-backdrop"></div>
        <div class="modal-content animate-scale-in">
          <div class="checkmark-wrapper">
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
              <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
          </div>
          <h3 class="modal-title">{{ $t('modal_success') }}</h3>
          <p class="modal-desc">{{ $t('modal_desc') }}</p>

          <button @click="handleSuccessRedirect" class="modal-btn">{{goto? $t('modal_btn'):$t('modal_btnbase') }}</button>
        </div>
      </div>
    </transition>
    <followWx v-model="showFollow" @finish="onFollowFinish" />
  </div>
</template>

<script>
import request from '@/utils/request'
import { formatDate, getUrlKey,GetDiveTitle } from '@/utils/base'
import { Button, Skeleton, Icon, Toast } from 'vant'
import languageChangeVue from '@/components/languageChange.vue'
import followWx from '@/components/followWx'
// 翻译字典
const translations = {
  'zh': {
    'title': '绑定行程',
    'upcoming_trip': '即将开启的旅程',
    'trip_on': '行程时间',
    'cabin': '预订舱位',
    'diveCenter':'潜水中心',
    'verify_info': '请确认您的信息',
    'last_name': '姓',
    'first_name': '名',
    'chinese_name': '中文姓名',
    'tip_1': '*请核对行程日期、姓名是否和自己一致;',
    'tip_2': '*若非本人姓名，请勿绑定;',
    'btn_confirm': '确认无误，绑定行程',
    'loading': '绑定中...',
    'modal_success': '绑定成功！',
    'modal_desc': '行程已添加至您的行程列表',
    'modal_btn': '填写出海申报',
    'modal_btnbase':'查看我的行程',
  },
  'en': {
    'title': 'Bind Itinerary',
    'upcoming_trip': 'Upcoming Trip',
    'trip_on': 'Trip on',
    'cabin': 'Cabin',
    'diveCenter':'Dive Center',
    'verify_info': 'Verify Your Info',
    'last_name': 'Last Name',
    'first_name': 'First Name',
    'chinese_name': 'Chinese Name',
    'tip_1': '*Please verify that the trip date and name match yours;',
    'tip_2': '*Do not bind if this is not your name;',
    'btn_confirm': 'Confirm & Bind',
    'loading': 'Processing...',
    'modal_success': 'Success!',
    'modal_desc': 'Trip has been added to your list',
    'modal_btn': 'Submit Declaration',
    'modal_btnbase':'View My Trips'
  }
};

export default {
  name: 'BindTrip',
  computed: {
    currentLang() {
      return this.$store.state.user.currentLang
    },
  },
  components: {
    languageChangeVue,
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [Icon.name]: Icon,
    followWx
  },
  data() {
    return {
      titleTop:'',
      loading: true,
      buttonLoading: false,
      hashCode: undefined,
      showSuccessModal: false,
      // 核心数据模型
      data: { 
        courseName: '', 
        diveCenter: '', 
        lastName: '', 
        firstName: '', 
        localName: '' 
      },
      startTime: '',
      // 路由参数
      goto: undefined,
      studentId: undefined,
      successTripId: undefined,
      showFollow:false,
      buttonDisable: true,
    }
  },
  created() {
    this.hashCode = this.$route.params.id
    this.goto = getUrlKey('goto')
    this.studentId = getUrlKey('studentId')
    this.titleTop = GetDiveTitle()
    this.init()
  },
  methods: {
    // 翻译辅助
    $t(key) { return translations[this.currentLang][key] || key; },
    
    // 返回上一页
    goBack() { window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/') },
    
    // 初始化数据
    init() {
      this.loading = true
      request({
        url: '/DiveTrip/getDiveTripBindData',
        method: 'post',
        data: { hashCode: this.hashCode }
      }).then(response => {
        this.titleTop = GetDiveTitle()
        this.loading = false
        if (!response.success) { Toast.fail('获取行程信息失败'); return }
        this.data = response.data
        this.startTime = formatDate(this.data.startTime, 'yyyy/MM/dd')
      }).catch(() => { 
        this.loading = false; 
        Toast.fail('网络请求错误') 
      })
    },
    onFollowFinish(){
      console.log("onFollowFinish")
      this.buttonDisable = false
      this.onBind()
    },
    // 绑定操作
    onBind() {
      if (this.loading) return

      if (this.buttonDisable === true) {
        this.showFollow = true
        return
      }

      this.buttonLoading = true
      request({
        url: '/DiveTrip/BindDiveTrip',
        method: 'post',
        // 必须保留空参数以符合后端可能的校验
        data: { hashCode: this.hashCode, birthdayDay: this.data.birthdayDay, localNameLast: '' }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
           if(this.goto && this.studentId){
             this.$router.push('/divetrip/liveaboardexpand/' + this.studentId)
           } else {
             Toast.fail(response.msg || '绑定失败')
           }
           return;
        }
        // 成功，显示弹窗
        this.successTripId = response.data
        this.showSuccessModal = true
      }).catch(() => { 
        this.buttonLoading = false; 
        Toast.fail('请求异常') 
      })
    },
    
    // 成功后跳转
    handleSuccessRedirect() {
      this.showSuccessModal = false
      if (this.goto) { 
        this.$router.push('/divetrip/liveaboardexpand/' + this.successTripId) 
      } else { 
        this.$router.push('/divetrip/trip/' + this.successTripId) 
      }
    }
  }
}
</script>

<style scoped>
/* 【修改点2】全局添加 box-sizing 解决宽度溢出问题 */
* {
  box-sizing: border-box;
}

/* 基础重置 */
.page-container {
  background-color: #F9FAFB;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 8rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0A2540;
}

/* 顶部 Header */
.header {
  background: white;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 40;
}
.header-content {
  max-width: 28rem;
  margin: 0 auto;
  padding: 0 1rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.back-btn {
  position: absolute;
  left: 1rem;
  height: 100%;
  display: flex;
  align-items: center;
  color: #9ca3af;
  transition: color 0.3s;
}
.page-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0A2540;
}

/* 主内容区域 */
.main-content {
  flex: 1;
  width: 100%;
  max-width: 28rem;
  margin: 0 auto;
  padding: 1rem;
}
.card {
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.03);
  border: 1px solid #f3f4f6;
  overflow: hidden;
  margin-bottom: 1.5rem;
}

/* 行程卡片样式 */
.card-image-wrapper {
  height: 8rem;
  background: #e5e7eb;
  position: relative;
}
.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.img-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.6), transparent);
}
.img-text {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  color: white;
  z-index: 2;
}
.img-subtitle {
  font-size: 0.75rem;
  opacity: 0.8;
  font-weight: 500;
  margin-bottom: 0.25rem;
}
.img-title {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.025em;
  margin: 0;
}

.card-body {
  padding: 1.25rem;
}
.info-row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.info-row:last-child { margin-bottom: 0; }

.icon-box {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #EFF6FF;
  color: #0057FF;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.125rem;
}
.label-text {
  font-size: 0.75rem;
  color: #9ca3af;
  margin-bottom: 0.125rem;
}
.value-text {
  font-size: 0.875rem;
  font-weight: 700;
  color: #0A2540;
}

/* 个人信息卡片样式 */
.info-card {
  padding: 1.5rem;
}
.card-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #f9fafb;
  padding-bottom: 1rem;
}
.header-icon {
  color: #0057FF;
  font-size: 1.2rem;
}
.header-title {
  font-weight: 700;
  color: #0A2540;
  margin: 0;
}
.info-list > div {
  margin-bottom: 1.25rem;
}
.info-label {
  font-size: 0.625rem;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.25rem;
}
.info-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0A2540;
  letter-spacing: -0.025em;
}

/* 提示框样式 */
.tip-box {
  background: rgba(239, 246, 255, 0.5);
  border-radius: 0.75rem;
  padding: 1rem;
  border: 1px solid rgba(219, 234, 254, 0.5);
}
.tip-content {
  display: flex;
  gap: 0.5rem;
}
.tip-icon {
  color: #0057FF;
  font-size: 0.875rem;
  margin-top: 0.125rem;
}
.tip-text {
  font-size: 0.75rem;
  color: #6b7280;
  line-height: 1.6;
}
.tip-text p {
  margin: 0 0 0.25rem 0;
}

/* 底部按钮栏 */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #e5e7eb;
  padding: 1rem;
  z-index: 50;
}
.footer-inner {
  max-width: 28rem;
  margin: 0 auto;
}
/* 强制覆盖 Vant 按钮样式 */
.confirm-btn {
  border-radius: 0.75rem !important;
  height: 56px !important;
  box-shadow: 0 10px 30px -5px rgba(0, 87, 255, 0.3);
  font-weight: 700 !important;
  font-size: 1rem !important;
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.6);
  backdrop-filter: blur(4px);
}
.modal-content {
  background: white;
  border-radius: 1.5rem;
  padding: 2rem;
  width: 85%;
  max-width: 24rem;
  position: relative;
  z-index: 10;
  text-align: center;
}
.modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0A2540;
  margin-bottom: 0.25rem;
}
.modal-desc {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}
.modal-btn {
  width: 100%;
  padding: 0.75rem;
  border-radius: 0.75rem;
  background: #f3f4f6;
  color: #0A2540;
  font-weight: 700;
  font-size: 0.875rem;
  transition: background 0.3s;
  border: none;
  cursor: pointer;
}
.modal-btn:hover {
  background: #e5e7eb;
}

/* 勾选动画 CSS */
.checkmark { width: 56px; height: 56px; border-radius: 50%; display: block; stroke-width: 2; stroke: #fff; stroke-miterlimit: 10; margin: 0 auto 1rem auto; box-shadow: inset 0px 0px 0px #10B981; animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both; }
.checkmark__circle { stroke-dasharray: 166; stroke-dashoffset: 166; stroke-width: 2; stroke-miterlimit: 10; stroke: #10B981; fill: none; animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards; }
.checkmark__check { transform-origin: 50% 50%; stroke-dasharray: 48; stroke-dashoffset: 48; animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards; }

@keyframes stroke { 100% { stroke-dashoffset: 0; } }
@keyframes scale { 0%, 100% { transform: none; } 50% { transform: scale3d(1.1, 1.1, 1); } }
@keyframes fill { 100% { box-shadow: inset 0px 0px 0px 30px #10B981; } }

/* 弹窗进入动画 */
.animate-scale-in { animation: scaleIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
@keyframes scaleIn { 0% { transform: scale(0.9); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }

.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>